/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sad_Quaint_Zebra_SpinInputs */

const es_sad_quaint_zebra_spin = /** @type {(inputs: Sad_Quaint_Zebra_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

const gl_sad_quaint_zebra_spin = /** @type {(inputs: Sad_Quaint_Zebra_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

const en_sad_quaint_zebra_spin = /** @type {(inputs: Sad_Quaint_Zebra_SpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Sad_Quaint_Zebra_SpinInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const sad_quaint_zebra_spin = /** @type {((inputs?: Sad_Quaint_Zebra_SpinInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sad_Quaint_Zebra_SpinInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_sad_quaint_zebra_spin(inputs)
	if (locale === "en") return en_sad_quaint_zebra_spin(inputs)
	return es_sad_quaint_zebra_spin(inputs)
});